import { IModuleStateManager } from '@msdyn365-commerce-modules/checkout-utilities';
import { IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
import { CategoryPath, ProductPrice, ProductSearchResult, SimpleProduct } from "@msdyn365-commerce/retail-proxy";
import { IOrderSummaryLines } from '@msdyn365-commerce-modules/order-summary-utilities';

export interface IModuleStatePropsExt {
    moduleState: IModuleStateManagerExt;
}

export interface IModuleStateManagerExt extends IModuleStateManager {
    init(options?: Partial<IModuleStateManagerExt>): void;
    wide?: boolean;
}

export interface IProductError {
    RecordId: number;
    Error: string;
    Type: 'warning' | 'error';
}

export interface IProductExtended {
    AlcoholPercentage?: string;
    Badge?: string;
    Brand?: string;
    Category?: string;
    CategoryPaths?: CategoryPath[];
    Country?: string;
    CountryAndDistrict?: string;
    District?: string;
    Manufacturer?: string;
    OutOfAssortment?: boolean;
    Producer?: string;
    ProductPrice?: ProductPrice;
    SoldOutUnknownDate?: boolean;
    SoldOutUntilDate?: Date;
    Vintage?: string;
    VolumeCl?: string;
}

export interface ProductSearchResultExt extends ProductSearchResult, IProductExtended {
    PrefetchedPrice?: boolean;
    PriceFailed?: boolean;
}

export interface SimpleProductExt extends SimpleProduct, IProductExtended {
}

export interface ProductPriceExt extends ProductPrice {
    OverrideDiscountPercentage?: number;
}

export interface IProductRefinerHierarchyExt extends IProductRefinerHierarchy {
    DisableSortValues?: boolean;
    RangeToPredefinedRanges?: boolean;
}

export interface IOrderSummaryLinesExt extends IOrderSummaryLines {
    charges?: React.ReactNode[];
}

export enum LifeCycleStatus {
    SoldOutUnknownDate = '20'
}
